
import './App.css';

import Routing from './Router';

import "./App.css";


function App() {
  return (
    <>
   
      <Routing />
    </>
  );
}

export default App;
